module.exports = __webpack_public_path__ + "media/icons/key-1-e7f3cbdf.svg";